var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEffortlyInsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 166,
    viewBox: "0 0 394 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 79.4137,
    width: 10.1379,
    height: 22.8103,
    rx: 5.06897,
    fill: "#8B68DB",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.9224,
    y: 79.8361,
    width: 9.2931,
    height: 21.9655,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40.708,
    y: 45.6206,
    width: 10.1379,
    height: 33.7931,
    rx: 5.06897,
    fill: "#D668CF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41.1304,
    y: 46.043,
    width: 9.2931,
    height: 32.9483,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 55.9142,
    y: 62.5171,
    width: 10.1379,
    height: 16.8966,
    rx: 5.06897,
    fill: "#8B68DB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56.3366,
    y: 62.9395,
    width: 9.2931,
    height: 16.0517,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 333.862,
    y: 62.5171,
    width: 10.1379,
    height: 16.8966,
    rx: 5.06897,
    fill: "#8B68DB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 334.285,
    y: 62.9395,
    width: 9.2931,
    height: 16.0517,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 71.1211,
    y: 54.9138,
    width: 10.1379,
    height: 24.5,
    rx: 5.06897,
    fill: "#D668CF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 71.5435,
    y: 55.3362,
    width: 9.2931,
    height: 23.6552,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 349.07,
    y: 54.9138,
    width: 10.1379,
    height: 24.5,
    rx: 5.06897,
    fill: "#D668CF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 349.493,
    y: 55.3362,
    width: 9.2931,
    height: 23.6552,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 86.328,
    y: 67.5862,
    width: 10.1379,
    height: 11.8276,
    rx: 5.06897,
    fill: "#8B68DB"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7504,
    y: 68.0086,
    width: 9.2931,
    height: 10.9828,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 101.535,
    y: 79.4137,
    width: 10.1379,
    height: 13.5172,
    rx: 5.06897,
    fill: "#D668CF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 101.958,
    y: 79.8361,
    width: 9.2931,
    height: 12.6724,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 116.742,
    y: 45.6206,
    width: 10.1379,
    height: 33.7931,
    rx: 5.06897,
    fill: "#8B68DB"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 117.165,
    y: 46.043,
    width: 9.2931,
    height: 32.9483,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 131.948,
    y: 79.4137,
    width: 10.1379,
    height: 33.7931,
    rx: 5.06897,
    fill: "#D668CF",
    fillOpacity: 0.2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 132.371,
    y: 79.8361,
    width: 9.2931,
    height: 32.9483,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 299.225,
    y: 79.4137,
    width: 10.1379,
    height: 33.7931,
    rx: 5.06897,
    fill: "#8B68DB",
    fillOpacity: 0.2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 299.647,
    y: 79.8361,
    width: 9.2931,
    height: 32.9483,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 147.156,
    y: 79.4137,
    width: 10.1379,
    height: 59.9828,
    rx: 5.06897,
    fill: "#8B68DB",
    fillOpacity: 0.2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 147.579,
    y: 79.8361,
    width: 9.2931,
    height: 59.1379,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 314.432,
    y: 79.4137,
    width: 10.1379,
    height: 59.9828,
    rx: 5.06897,
    fill: "#D668CF",
    fillOpacity: 0.2
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 314.854,
    y: 79.8361,
    width: 9.2931,
    height: 59.1379,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 162.362,
    y: 79.4137,
    width: 10.1379,
    height: 18.5862,
    rx: 5.06897,
    fill: "#D668CF",
    fillOpacity: 0.2
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 162.785,
    y: 79.8361,
    width: 9.2931,
    height: 17.7414,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 177.569,
    y: 79.4137,
    width: 10.1379,
    height: 10.1379,
    rx: 5.06897,
    fill: "#8B68DB",
    fillOpacity: 0.2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 177.992,
    y: 79.8361,
    width: 9.2931,
    height: 9.2931,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 192.777,
    y: 79.4137,
    width: 10.1379,
    height: 26.1897,
    rx: 5.06897,
    fill: "#D668CF",
    fillOpacity: 0.2
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 193.2,
    y: 79.8361,
    width: 9.2931,
    height: 25.3448,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 207.984,
    y: 58.2931,
    width: 10.1379,
    height: 21.1207,
    rx: 5.06897,
    fill: "#8B68DB"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 208.406,
    y: 58.7155,
    width: 9.2931,
    height: 20.2759,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 223.19,
    y: 69.2759,
    width: 10.1379,
    height: 10.1379,
    rx: 5.06897,
    fill: "#D668CF"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 223.613,
    y: 69.6983,
    width: 9.2931,
    height: 9.2931,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 238.397,
    y: 51.5344,
    width: 10.1379,
    height: 27.8793,
    rx: 5.06897,
    fill: "#8B68DB"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 238.819,
    y: 51.9568,
    width: 9.2931,
    height: 27.0345,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 253.604,
    y: 79.4137,
    width: 10.1379,
    height: 18.5862,
    rx: 5.06897,
    fill: "#D668CF",
    fillOpacity: 0.2
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 254.026,
    y: 79.8361,
    width: 9.2931,
    height: 17.7414,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 268.812,
    y: 46.4653,
    width: 10.1379,
    height: 32.9483,
    rx: 5.06897,
    fill: "#8B68DB"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 269.234,
    y: 46.8877,
    width: 9.2931,
    height: 32.1035,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 284.018,
    y: 69.2759,
    width: 10.1379,
    height: 10.1379,
    rx: 5.06897,
    fill: "#D668CF"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 284.44,
    y: 69.6983,
    width: 9.2931,
    height: 9.2931,
    rx: 4.64655,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.844828
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 386.931,
    height: 165.586,
    fill: "url(#pattern0_1_1656)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1_1656",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_1656",
    transform: "scale(0.000684932 0.00158983)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_1656",
    width: 1460,
    height: 629,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffortlyInsight);
export default __webpack_public_path__ + "static/media/effortly-insight.5b3e2b1f2f67cf0775cae9ef6eebd20c.svg";
export { ForwardRef as ReactComponent };